module.exports = __webpack_public_path__ + "img/prepare-bible-study-cropped-2.991f9e29.jpg";